import { useRef, useState } from "react";
import SearchFilterComponent from "../Common/SearchFilterComponent/SearchFilterComponent";
import styles from "./index.module.scss";
import IntegrationsTable from "./integrations-table";

const IntegrationsPage = () => {
  const searchInputRef = useRef<HTMLInputElement>(null);
  const [searchValue, setSearchValue] = useState('');

  const handleSearchOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value);
  };

  const handleSearchOnCross = () => {
    setSearchValue('');
  };

  return (
    <div className={styles.page}>
      <SearchFilterComponent
        leftSide={
          <div>
            <span className={styles.title}>
              Integrations
            </span>
          </div>
        }
        searchValue={searchValue}
        searchOnChange={handleSearchOnChange}
        searchOnCross={handleSearchOnCross}
        passedRef={searchInputRef}
        setRef={() => {
          searchInputRef.current?.focus();
        }}
      />
      <IntegrationsTable />
    </div>
  );
};

export default IntegrationsPage;
